import { httpClient } from '../http/httpClient'
import {
  SupportRequest,
  SupportRequestReason,
  SupportRequestStatusEnum,
} from '@/app/entities/SupportRequest'

/**
 * 'oldest': mais antigos primeiro · 'recent': atualizados por último primeiro
 * 'pending': em aberto primeiro, do mais antigo pro mais novo
 * 'unassigned': sem responsável primeiro, depois a mesma ordem de 'pending'
 */
export type SupportRequestListSort =
  | 'oldest'
  | 'recent'
  | 'pending'
  | 'unassigned'

export interface ListMySupportRequestsParams {
  search?: string
  status?: SupportRequestStatusEnum[]
  reason?: SupportRequestReason[]
  // motivos que não entram na lista (ex.: WHATSAPP_DIRECT na contagem de abertos)
  excludeReason?: SupportRequestReason[]
  limit?: number
  skip?: number
  // null: só os chamados sem responsável
  assignedTo?: string | null
  hasAssignee?: boolean
  sort?: SupportRequestListSort
  searchId?: string
}

export interface ListMySupportRequestsResponse {
  supportRequests: SupportRequest[]
  pagination: {
    limit: number
    skip: number
    total: number
  }
}

export async function listSupportRequests(
  params?: ListMySupportRequestsParams,
) {
  const { status, reason, excludeReason, assignedTo, ...rest } = params || {}

  const { data } = await httpClient.get<ListMySupportRequestsResponse>(
    '/support-requests',
    {
      params: {
        ...rest,
        status: status && status.length > 0 ? status.join(',') : undefined,
        reason: reason && reason.length > 0 ? reason.join(',') : undefined,
        excludeReason:
          excludeReason && excludeReason.length > 0
            ? excludeReason.join(',')
            : undefined,
        assignedTo: assignedTo === null ? 'null' : assignedTo,
      },
    },
  )

  return data
}
